module.exports = __webpack_public_path__ + "img/ImportStudent2.95e698f1.png";